// Module
var code = "<p>[# summary]</p> <h3 id=\"asset-symbol\">Asset {symbol}</h3> <p>{description} </p> <p>Issued by: {issuer}</p> <p>The United States dollar (sign: $; symbol: USD) is the official currency of the United States of America.</p> ";
// Exports
export default code;